/* SOFFA HAUS motion system (§3.14, 2026-09-17): noom-level scroll reveals.
   The hidden state is gated on the root class added here, so without JS — or
   with prefers-reduced-motion — nothing is ever hidden. Elements opt in with
   class="soffa-reveal" in liquid, or are auto-tagged below; data-reveal-delay
   (0–3) staggers siblings, .soffa-reveal-zoom settles the inner image from an
   oversized scale (noom's image entrance). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  /* the theme editor reloads sections constantly — keep everything visible there */
  if (window.Shopify && window.Shopify.designMode) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('soffa-reveal--in');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  /* [selector, options]
     stagger: sibling index modulo N → data-reveal-delay (one row shares a wave)
     zoom:    also settle the inner image (container must clip — see theme.liquid)
     zoomOnly: element already carries .soffa-reveal in liquid — just add the zoom */
  var AUTO = [
    ['.section-resource-list__header', {}],
    ['.email-signup-block', {}],
    ['.soffa-brand-band', {}],
    ['.soffa-principle-cards__card', { stagger: 3 }],
    ['.soffa-category-tiles__tile', { stagger: 4, zoom: true }],
    /* direct children only — carousel clones (mobile/product carousels) stay untouched */
    ['.resource-list > .resource-list__item', { stagger: 4 }],
    ['.product-grid > .product-grid__item', { stagger: 4 }],
    /* product-page gallery only — .product-media-container also lives inside
       product-card slideshows, where hiding non-first slides breaks the card */
    ['media-gallery .product-media-container', { stagger: 3 }],
    ['.soffa-editorial-split__media', { zoomOnly: true }],
    ['.section-product-hotspots__content', { zoomOnly: true }]
  ];

  function tag() {
    AUTO.forEach(function (def) {
      var opts = def[1];
      var perParentIndex = [];
      var perParentNodes = [];
      document.querySelectorAll(def[0]).forEach(function (el) {
        if (opts.zoomOnly) {
          el.classList.add('soffa-reveal-zoom');
          return;
        }
        el.classList.add('soffa-reveal');
        if (opts.zoom) el.classList.add('soffa-reveal-zoom');
        if (opts.stagger && !el.hasAttribute('data-reveal-delay')) {
          var p = el.parentNode;
          var i = perParentNodes.indexOf(p);
          if (i === -1) {
            perParentNodes.push(p);
            perParentIndex.push(0);
            i = perParentNodes.length - 1;
          }
          var delay = perParentIndex[i] % opts.stagger;
          perParentIndex[i] += 1;
          if (delay > 0) el.setAttribute('data-reveal-delay', delay);
        }
      });
    });
  }

  function init() {
    tag();
    document.documentElement.classList.add('soffa-reveal-ready');
    document.querySelectorAll('.soffa-reveal:not(.soffa-reveal--in)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
